import React, { Component } from 'react';
import { Field } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import FormField from '../form-field';
import { formatMessage } from '../../lib/intl';

import '../../css/invitees.css';

const i18n = defineMessages({
  emailFieldPlaceholder: {
    id: 'claimForm.invitees.emailField.placeholder',
    defaultMessage: 'type or click to import',
  },
  fullNameFieldPlaceholder: {
    id: 'claimForm.invitees.fullNameField.placeholder',
    defaultMessage: 'name',
  },
})

export class Invitees extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
  }

  getEmailProps(invitee, config = {}) {
    const props = {
      name: `${invitee}.email`,
    };

    if (config.first) {
      return {
        ...props,
        label: <FormattedMessage
          id="claimForm.invitees.emailField.label"
          defaultMessage="Email"
        />,
        placeholder: this.formatMessage(i18n.emailFieldPlaceholder),
        onFocus: this.props.onEmailFocus,
        onBlur: this.props.onEmailBlur,
      };
    }

    if (config.last) {
      return {
        ...props,
        onBlur: this.props.onInviteesChange,
      }
    }

    return { ...props };
  }

  getNameProps(invitee, config = {}) {
    const props = { name: `${invitee}.fullName` };

    if (config.first) {
      return {
        ...props,
        placeholder: this.formatMessage(i18n.fullNameFieldPlaceholder),
        label: <FormattedMessage
          id="claimForm.invitees.fullNameField.label"
          defaultMessage="Name (optional)"
        />,
      };
    }

    return { ...props };
  }

  renderInviteeRow(invitee) {
    return inviteeRow(invitee, this.getEmailProps(invitee), this.getNameProps(invitee));
  }

  renderFirstInviteeRow(invitee) {
    const first = true;
    return inviteeRow(invitee, this.getEmailProps(invitee, { first }),
      this.getNameProps(invitee, { first }));
  }

  renderLastInviteeRow(invitee) {
    const last = true;
    return inviteeRow(invitee, this.getEmailProps(invitee, { last }),
      this.getNameProps(invitee, { last }));
  }

  render() {
    const { fields } = this.props;

    return (
      <div className="invitees contacts-field-container">
        {
          fields.map((invitee, i) => {
            if (i === 0) return this.renderFirstInviteeRow(invitee);
            if (i === fields.length - 1) return this.renderLastInviteeRow(invitee);
            return this.renderInviteeRow(invitee);
          })
        }
      </div>
    );
  }
}

const inviteeRow = (invitee, emailProps, nameProps) => (
  <div className="row" key={invitee}>
    <div className="col-6" key={`invitee-row-${invitee}-email`}>
      <Field {...emailProps} type="text" component={FormField} />
    </div>
    <div className="col-6" key={`invitee-row-${invitee}-name`}>
      <Field {...nameProps} type="text" component={FormField} />
    </div>
  </div>
);

Invitees.defaultProps = {
  onEmailFocus: () => { },
  onInviteesChange: () => { },
};

export default injectIntl(Invitees);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/invitees.js